import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBreadcrumb, clearBreadcrumb } from '../../store/features/navbarBreadcrumbSlice';

/**
 * Sets the navbar breadcrumb label/link to a company's overview page, and clears it on unmount.
 * Centralizes the setBreadcrumb/clearBreadcrumb pattern duplicated across several claim/claim-group pages.
 *
 * @param {object|null|undefined} company - the company object; must have `id` and `name`. Effect no-ops until this is truthy.
 * @param {string} accountType - the current account type, used to build the breadcrumb link path
 */
export function useSetCompanyBreadcrumb(company, accountType) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (company) {
      dispatch(setBreadcrumb({
        label: company.name,
        path: `/${accountType}/companies/${company.id}/overview`
      }));
    }
    return () => dispatch(clearBreadcrumb());
  }, [company, accountType, dispatch]);
}